import React, { useEffect, useState } from "react";
import TextMedium from "../TextComponent/TextMedium";
import { ResponsivePie } from "@nivo/pie";
import { useSelector } from "react-redux";
import { ReactComponent as ArrowDownIcon } from "../../../build/images/arrowdownmanager.svg";
import { ReactComponent as ArrowUpIcon } from "../../../build/images/arrowupmanager.svg";
import { ReactComponent as LoadingView } from "../../../build/images/loadingmanagerintentions.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { Tooltippy } from "../../../actions/Tippy";

let colors = [
  "#1E88E5",
  "#43A047",
  "#FFB300",
  "#C0CA33",
  "#D81B60",
  "#5E35B1",
  "#6D4C41",
  "#F4511E",
  "#646464",
  "#C90000",
  "#008908",
  "#F2BD00",
  "#455CC7",
];

function gerar_cor_hexadecimal() {
  return (
    "#" +
    parseInt(Math.random() * 0xffffff)
      .toString(16)
      .padStart(6, "0")
  );
}

let data = [];
let countIntentions = 0;
let intentionsDataFiltered = 0;

export default function CardPreferredIntentions({ title, classname = "" }) {
  const DataIntentions = useSelector((state) => state.datamanagerintentions);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const [pageScroll, setPageScroll] = useState(1);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const [intentionData, setIntentionsData] = useState([]);

  useEffect(() => {
    if (DataIntentions.length !== 0 && FiltersManager.is_active) {
      let jsonRefactored = [];
      data = [];
      countIntentions = 0;

      jsonRefactored = JSON.parse(DataIntentions);
      jsonRefactored = jsonRefactored.filter((filt) =>
        FiltersManager.filter_manager_service.includes(filt.idgrupo)
      );
      jsonRefactored = jsonRefactored.filter((filt) =>
        FiltersManager.filter_manager_channel.includes(filt.idmidia)
      );

      jsonRefactored.map((datum, index) => {
        countIntentions += datum.qtde_intencoes;
        data.push({
          id: datum.nomegrupo,
          label: datum.nomegrupo,
          value: datum.qtde_intencoes,
          color: index < 12 ? colors[index] : gerar_cor_hexadecimal(),
        });
      });
      intentionsDataFiltered = jsonRefactored;
      setIntentionsData(jsonRefactored);
    }
  }, [DataIntentions, FiltersManager]);

  const handleScroll = (set) => {
    let qtdPages = Math.ceil(data.length / 10);
    if (set === "up" && pageScroll !== 1) {
      setPageScroll(pageScroll - 1);
    } else if (set === "down" && pageScroll <= qtdPages) {
      setPageScroll(pageScroll + 1);
    }
  };

  return (
    <div
      className={`manager-component__card-preferred-intentions ${classname}`}
    >
      <div className="manager-component__card-preferred-intentions__title">
        <TextMedium text={title} color="gray" />
      </div>
      {LoginCompleteReducer.isLoginComplete ? (
        countIntentions !== 0 ? (
          <div className="manager-component__card-preferred-intentions__box">
            <div className="manager-component__card-preferred-intentions__box-chart">
              <ResponsivePie
                data={data}
                id="id"
                margin={{ top: 10, right: 10, bottom: 10, left: 0 }}
                innerRadius={0.6}
                padAngle={0}
                cornerRadius={0}
                activeInnerRadiusOffset={8}
                borderWidth={1}
                borderColor={{
                  from: "color",
                  modifiers: [["darker", 0.2]],
                }}
                isInteractive={false}
                enableArcLinkLabels={false}
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={2}
                arcLinkLabelsColor={{ from: "color" }}
                arcLabelsSkipAngle={10}
                arcLabelsTextColor="#f6f4f4"
                defs={[
                  {
                    id: "dots",
                    type: "patternDots",
                    background: "inherit",
                    color: "rgba(255, 255, 255, 0.3)",
                    size: 4,
                    padding: 1,
                    stagger: true,
                  },
                  {
                    id: "lines",
                    type: "patternLines",
                    background: "inherit",
                    color: "rgba(255, 255, 255, 0.3)",
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10,
                  },
                ]}
                colors={{ datum: "data.color" }}
              />
              <div
                className="manager-component__card-preferred-intentions__root-overlay"
                style={{ paddingLeft: countIntentions < 10 ? "39%" : "35%" }}
              >
                <strong>{countIntentions}</strong>
                {/* <span>Intenções</span> */}
              </div>
            </div>
            <div className="manager-component__card-preferred-intentions__box-itens">
              <ul>
                {data
                  .slice(
                    pageScroll === 1 ? 0 : (pageScroll - 1) * 8,
                    pageScroll * 8
                  )
                  .map((datum, index) => (
                    <div className="box-list__legends" key={index}>
                      <div
                        className="box-list__legends-circle"
                        style={{ backgroundColor: datum.color }}
                      ></div>
                      <Tooltippy content={datum.label}>
                        <span className="box-list__legends-text">
                          {datum.label}
                        </span>
                      </Tooltippy>
                    </div>
                  ))}
                {data.length > 8 && (
                  <div className="manager-component__card-preferred-intentions__box-itens__more">
                    <div
                      className={
                        pageScroll === 1
                          ? "manager_arrow-select-disable"
                          : "manager_arrow-select-enable"
                      }
                      onClick={() => handleScroll("up")}
                    >
                      <ArrowUpIcon />
                    </div>
                    <span>
                      {pageScroll}/{Math.ceil(data.length / 10)}
                    </span>
                    <div
                      className={
                        Math.ceil(data.length / 10) === pageScroll
                          ? "manager_arrow-select-disable"
                          : "manager_arrow-select-enable"
                      }
                      onClick={() => handleScroll("down")}
                    >
                      <ArrowDownIcon />
                    </div>
                  </div>
                )}
              </ul>
            </div>
          </div>
        ) : (
          <div className="manager-component__card-preferred-intentions__box-empty">
            <div className="manager_empty-state">
              <EmptyState />
            </div>
          </div>
        )
      ) : (
        <div className="manager-component__card-preferred-intentions__box-loading">
          <LoadingView />
        </div>
      )}
    </div>
  );
}
